export function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center pt-20" style={{
      backgroundImage: 'url(https://static.readdy.ai/image/17d917f43abf2e0d5a0666d8ddfb2811/740328b63a78fe85ce7503ac9bdce1b4.png)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    }}>
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/95 via-blue-900/85 to-transparent"></div>
      
      <div className="relative w-full max-w-7xl mx-auto px-6 py-24">
        <div className="max-w-3xl">
          <div className="inline-block px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20 mb-6">
            <span className="text-white/90 text-sm font-medium">🌍 Global Video & Event Media Partner</span>
          </div>
          
          <h2 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight">
            Connecting Your Brand<br />
            <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">to the World</span>
          </h2>
          
          <p className="text-xl md:text-2xl text-white/90 mb-10 leading-relaxed">
            Professional overseas video production, international conference media services, and cross-cultural communication solutions for global brands.
          </p>

          <div className="flex flex-wrap gap-4">
            <button 
              onClick={scrollToContact}
              className="px-8 py-4 bg-gradient-to-r from-blue-600 to-purple-600 text-white rounded-full font-semibold text-lg hover:shadow-2xl transition-all whitespace-nowrap cursor-pointer"
            >
              Get Free Quote
            </button>
            <button 
              onClick={scrollToContact}
              className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white rounded-full font-semibold text-lg border-2 border-white/30 hover:bg-white/20 transition-all whitespace-nowrap cursor-pointer"
            >
              Schedule Consultation
            </button>
          </div>

          <div className="mt-16 grid grid-cols-3 gap-8">
            <div>
              <div className="text-4xl font-bold text-white mb-2">500+</div>
              <div className="text-white/80">Global Projects</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-white mb-2">50+</div>
              <div className="text-white/80">Countries Served</div>
            </div>
            <div>
              <div className="text-4xl font-bold text-white mb-2">98%</div>
              <div className="text-white/80">Client Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
